import { useAtom } from "jotai"
import { signIn } from "next-auth/react"
import { useForm } from "react-hook-form"

import { ActionButton } from "components/Button"
import FaIcon from "components/FontAwesomeIcon"
import { ErrorMessage, Input } from "components/forms/FormElements"
import { signInAlertAtom, signInErrors } from "pages/sign-in"

import type { SignInFormType } from "pages/sign-in"

const SignInEmail: React.FC<{
  variant?: Omit<SignInFormType, "signIn">
}> = ({ variant = "signInEmail" }) => {
  const rhf = useForm<{
    email: string
  }>({
    shouldUnregister: true
  })

  const [, setSignInAlert] = useAtom(signInAlertAtom)

  return (
    <>
      <form
        onSubmit={rhf.handleSubmit(async () => {
          const emailRes = await signIn("email", {
            redirect: false,
            email: rhf.getValues("email")
          })

          if (emailRes?.error) {
            setSignInAlert({
              content: signInErrors[emailRes.error as "Default"],
              show: true,
              variant: "error"
            })
          } else {
            setSignInAlert({
              content: "Check your email for a link to sign in",
              show: true,
              variant: "success"
            })
          }
        })}
      >
        <div>
          <Input
            type="email"
            autoComplete="email"
            showRequired
            {...rhf.register("email", { required: true })}
          />
          {rhf.formState.errors.email && (
            <ErrorMessage>Please enter your email address</ErrorMessage>
          )}
        </div>
        <div className=" flex items-center gap-4 p-3 bg-gray-100 rounded font-bold text-sm my-3">
          <FaIcon icon="wand-magic-sparkles" />
          <span>
            We&rsquo;ll email you a magic link to sign{" "}
            {variant === "signUp" ? "up" : "in"}. Look out for an email from us.
          </span>
        </div>
        <ActionButton kind="submit" isLoading={rhf.formState.isSubmitting}>
          {variant === "signUp" ? "Sign up" : "Sign in via email"}
        </ActionButton>
      </form>
    </>
  )
}

export default SignInEmail
